export const AUTH_ERRORS = {
    INVALID_OTP: { code: "auth_invalid_otp", message: "Code de vérification invalide" },
    OTP_EXPIRED: { code: "auth_otp_expired", message: "Code de vérification expiré" },
    OTP_MAX_ATTEMPTS: { code: "auth_otp_max_attempts", message: "Trop de tentatives, demandez un nouveau code" },
    OTP_RATE_LIMITED: { code: "auth_otp_rate_limited", message: "Trop de demandes, réessayez plus tard" },
    OTP_SEND_FAILED: { code: "auth_otp_send_failed", message: "L'envoi du code a échoué, réessayez" },
    INVALID_REFRESH_TOKEN: { code: "auth_invalid_refresh_token", message: "Session invalide, reconnectez-vous" },
    REFRESH_TOKEN_EXPIRED: { code: "auth_refresh_token_expired", message: "Session expirée, reconnectez-vous" },
    ACCOUNT_BLOCKED: { code: "auth_account_blocked", message: "Compte suspendu" },
};
